<dw-grid-list-page
  [title]="'Doc::Menu:InventoryCounts' | abpLocalization"
  [activeView]="agGrid.activeView"
  (createAction)="createEntity()"
  [createActionLabel]="'::Add'"
  [enableExportBtn]="enableExport"
  [enableDeleteBtn]="enableDelete"
  (exportAction)="agGrid.export()"
  (deleteAction)="deleteEntities()"
  [hasQuickSearch]="true"
  class="h-100"
>
  <dw-grid-ag-grid
    [columnDefs]="colDefs"
    [datasource]="datasource"
    [alwaysProjectedColumns]="['workerFirstName', 'workerLastName']"
    (rowClicked)="rowClicked($event)"
    (selectedRowsClicked)="selectedRowsClicked($event)"
    [(selectedRows)]="selectedEntities"
    #agGrid
    [context]="GoliathDocumentEntityNames.InventoryCountDoc.shortName"
  >
  </dw-grid-ag-grid>
</dw-grid-list-page>
